import { render } from "./AdminPackages.vue?vue&type=template&id=2dcf4af4&scoped=true&ts=true&lang=pug"
import script from "./AdminPackages.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminPackages.vue?vue&type=script&lang=ts&setup=true"

import "./AdminPackages.vue?vue&type=style&index=0&id=2dcf4af4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcf4af4"]])

export default __exports__